import { clients } from '../lib/https';
import { useModelStore } from '../state/store/chat/use-model-store';
// import { Atom } from 'lucide-react';
import { ModelTypes } from 'features/chat/types/model.types';
import { ConfigurationSettings } from '/models/configuration-settings';
import modelIcon from '../assets/images/modelIcon.svg';
import {
  LlmModelProviderLabel,
  LlmModelRegion,
} from '../constant/llm-model';

export interface ILlmModelGetDTO {
  itemId: string;
  modelName: string;
  modelDisplayName: string;
  modelDescription: string;
  modelType: string;
  isActive: boolean;
  isThinkingModel: boolean;
  isDefaultModel: boolean;
  order: number;
  hasDynamicThinking?: boolean;
  isHarmonicModel?: boolean;
  region: LlmModelRegion;
  providerLabel: LlmModelProviderLabel;
}

export const getLlmModels = async (config: ConfigurationSettings): Promise<ILlmModelGetDTO[]> => {
  // Model catalogue is served by taskforce (file-backed, operator-managed on deploy)
  // instead of the legacy seliseai ModelConfiguration service.
  const url = `${config.paths.seliseAiBaseUrl}${config.paths.seliseAi.models}`;
  const models = await clients.get<ILlmModelGetDTO[]>(url, config.blocksKey);
  if (models) {
    const mappedModel = models
      .filter((model) => model.isActive)
      .sort((a, b) => a.order - b.order)
      .map((model) => {
        const icon = <img src={modelIcon} alt={model.modelDisplayName} className="w-4 h-4" />;

        const isDeepSeek =
          model.modelName?.toLowerCase().includes('deepseek') ||
          model.modelDisplayName?.toLowerCase().includes('deepseek');
        const modelType =
          isDeepSeek || model.modelType !== 'NonVision'
            ? ModelTypes.VISION
            : ModelTypes.NO_VISION;

        return {
          id: model.modelName,
          name: model.modelDisplayName,
          description: model.modelDescription,
          modelType,
          isThinkingModel: model.isThinkingModel,
          icon: icon,
          isDefaultModel: model.isDefaultModel,
          order: model.order,
          hasDynamicThinking: model.hasDynamicThinking ?? false,
          isHarmonicModel: model.isHarmonicModel ?? false,
          region: model.region,
          providerLabel: model.providerLabel,
        };
      });
    useModelStore.getState().setModels(mappedModel);
  }
  return models;
};
